export const de = {
    en: 'EN',
    tr: 'TR',
    fr: 'FR',
    de: 'DE',
    sports: 'Sports',
    live: 'Live',
    today: 'Today',
    highlights: 'Highlights',
    results: 'Results',
    lastMinute: 'Last Minute',
    liveCasino: 'Live Casino',
    casino: 'Casino',
    myBets: 'My Bets',
    home: 'Home',
    betslip: 'Betslip',
    search: 'Search',
    searchHere: 'Search here',
    transaction: 'Transaction',
    changePassword: 'Change password',
    logout: 'Logout',
    single: 'Single',
    multiple: 'Multiple',
    possibleWin: 'Possible win',
    amount: 'Amount',
    ok: 'Ok',
    totalOdds: 'Total odds',
    totalPossibleWin: 'Total possible win',
    placeBet: 'Place bet',
    fastBet: 'Fast bet',
    username: 'Username',
    password: 'Password',
    stayLoggedIn: 'Stay logged in',
    login: 'Anmeldung',
    all: 'All',
    inGame: 'In Game',
    won: 'Won',
    lost: 'Lost',
    date: 'Date',
    winAmount: 'Win amount',
    stake: 'Stake',
    pick: 'Pick',
    myAccount: 'My Account',
};
